<template>
  <div id="AnswerResultView">
    <h1 style="text-align: center">答题结果</h1>
    <a-card>
      <a-row style="margin-bottom: 16px">
        <a-col flex="auto" class="content-wrapper">
          <h2>{{ data.resultName }}</h2>
          <div v-if="APP_TYPE_MAP[data.appType!] === '得分类'">
            <p>结果得分：{{ data.resultScore }}</p>
          </div>
          <p>结果描述：{{ data.resultDesc }}</p>
          <p>应用类型：{{ APP_TYPE_MAP[data.appType!] }}</p>
          <p>评分策略：{{ APP_SCORING_STRATEGY_MAP[data.scoringStrategy!] }}</p>
          <P>我的答案：{{ data.choices }}</P>
          <p>
            答题时间：
            {{ dayjs(data.createTime).format("YYYY-MM-DD HH:mm:ss") }}
          </p>
          <p>
            答题人：
            <a-avatar
              :size="24"
              :style="{ marginRight: '8px' }"
              :image-url="data.user?.userAvatar"
            >
            </a-avatar>
            <a-typography-text>
              {{ data.user?.userName || "匿名" }}
            </a-typography-text>
          </p>
          <p>应用 id:{{ data.appId }}</p>
          <p>结果 id:{{ data.resultId }}</p>
          <a-space size="medium">
            <a-button type="secondary" :href="`/answer/do/${data.appId}`"
              >重新答题
            </a-button>
            <a-button type="primary" :href="`/`">返回主页 </a-button>
          </a-space>
        </a-col>
        <a-col flex="320px">
          <div>
            <a-image :src="data?.resultPicture" width="100%" />
          </div>
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>

<script setup lang="ts">
//@ts-ignore
import { ref, watchEffect, withDefaults, defineProps, computed } from "vue";
import API from "@/api";
import message from "@arco-design/web-vue/es/message";
import { APP_SCORING_STRATEGY_MAP, APP_TYPE_MAP } from "@/constant/app";
import dayjs from "dayjs";
import { useLoginUserStore } from "@/store/useStore";
import { getUserAnswerVoByIdUsingGet } from "@/api/userAnswerController";

const data = ref<API.UserAnswerVO>({});

interface Props {
  id: string;
}

const props = withDefaults(defineProps<Props>(), {
  id: () => "",
});

// 加载数据
const loadData = async () => {
  if (!props.id) {
    message.error("应用不存在");
    return;
  }
  const res = await getUserAnswerVoByIdUsingGet({ id: props.id as any });
  if (res.data.code === 0) {
    data.value = res.data.data as any;
  } else {
    message.error("获取数据失败，" + res.data.message);
  }
};

/**
 * 监听 searchParams 变量：触发加载
 */
watchEffect(() => {
  loadData();
});

//获取登录用户
const loginUserStore = useLoginUserStore();
let loginUserId = loginUserStore.loginUser?.id;

//是不是本人创建的应用
const isMy = computed(() => {
  return loginUserId && loginUserId === data.value.userId;
});
</script>

<style scoped>
#AnswerResultView {
}

#AnswerResultView .content-wrapper > * {
  margin-bottom: 24px;
}
</style>
